import React, { PropTypes, Component } from "react";

class ContentSection extends Component {
	render() {
		return (
			<div className={(this.props.rightPane ? "" : "expanded") + " page-mainarea"}>{this.props.children}</div>
		);
	}
}

ContentSection.propTypes = {
	rightPane: PropTypes.bool.isRequired,
};

export default ContentSection;


/** WEBPACK FOOTER **
 ** ./src/scripts/components/ContentSection.jsx
 **/